import src from "IMAGE";
export default { src, width: 93, height: 6, blurWidth: 0, blurHeight: 0};
